import React, { useEffect, useState } from "react";
import FormGroup from "react-bootstrap/lib/FormGroup";
import {
  newsletterAPI,
} from "../../../public/constants/constants";
import apiManager from "../../utils/apiManager";
import { isMobile } from "../../utils/utilityManager";
import "../../../public/styles/blog/newsletter.scss";
import { regexEmail, validateEmptyObject } from "../../utils/validationManager";

function BlogNewsletter(props) {
  const [inputText, setInputText] = useState("");
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const handleInputChange = text => {
    setInputText(text.target.value);
  };

  useEffect(() => {
    console.log(props,'propssss')
  }, [])

  const doneBtnPressed = () => {
    if (!validateEmptyObject(inputText)) {
      setError(true);
      setErrorMessage("This Field is Required");
      return;
    }

    if (!regexEmail.test(inputText)) {
      setError(true);
      setErrorMessage("Invalid Email address");
      return;
    }

    setError(false);

    const data = {
      email_id: inputText,
      pageName: "GI_B2C_BLOG",
    };
    apiManager
      .post(newsletterAPI, data)
      .then(response => {
        const {data} = response;
        console.log(response.data, "response.data");
        
        alert(`Thanks for Subscribing`);
        ()=>setInputText("");
      })
      .catch(error => {});
  };
  return isMobile() ? (
    <div className="newsletter-mobile">
      {props.homeImages &&
        props.homeImages.emailSubsBanner &&
        props.homeImages.emailSubsBanner.banner_rwd.url && (
        <div
          className="newsletter-heading"
          style={{
            backgroundImage: `url(${
              props.homeImages.emailSubsBanner.banner_rwd.url
            })`,
          }}
        >
        </div>
      )}
      <div className="subheading" id="newsletterSubscribe">
      Be inspired by ideas on better spaces, better living and living together with your loved ones.�
      </div>
      <div className="email-container">
        <FormGroup className="email">
          <input
            onChange={handleInputChange}
            type="text"
            name="text"
            id="exampleEmail"
            className="form-control newinputmargin"
            placeholder="Enter your e-mail address"
          />
        </FormGroup>
        <FormGroup className="news-letter-btn">
          <button onClick={() => doneBtnPressed()}>Subscribe</button>
        </FormGroup>
      </div>
    </div>
  ) : (
    <>
      {props.homeImages &&
        props.homeImages.emailSubsBanner &&
        props.homeImages.emailSubsBanner.banner.url && (
        <div
          id="newsletterSubscribe"
          className="newsletter"
          style={{
            backgroundImage: `url(${
              props.homeImages.emailSubsBanner.banner.url
            })`,
          }}
        >
          <div className="container newsletter-card-container">
            <div className="logo">
              {props.homeImages &&
                  props.homeImages.emailSubsLogo && (
                <img
                  src={props.homeImages.emailSubsLogo.thumbnail}
                  alt="logo"
                  className="photo"
                />
              )}
            </div>
            <div className="heading">Join our newsletter list.</div>
            <div className="subheading">
              Be inspired by ideas on better spaces, better living and living together with your loved ones.
            </div>
            <div className="email-container">
              <FormGroup className="email">
                <input
                  onChange={handleInputChange}
                  type="text"
                  name="text"
                  id="exampleEmail"
                  className="form-control newinputmargin"
                  placeholder={!isMobile() ? "Enter your e-mail address" : ""}
                />
                {error ?<p className="error-msg">{errorMessage}</p>:null}
              </FormGroup>
              <FormGroup className="news-letter-btn">
                <button onClick={() => doneBtnPressed()}>Subscribe</button>
              </FormGroup>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default BlogNewsletter;
